module.exports = __webpack_public_path__ + "static/media/window-maximize.e43375b9.svg";